<script>
import router from "@/router";
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  props: [
    'userType',
    'location'
  ],
  components: { Header , Footer },
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
    }
  },
  methods: {
    createAccount() {
        router.push({ name: 'create-account'})
    },
  },
}
</script>

<template>
  <div>
    <Header></Header>
    <section class="main-body">

      <div class="page-title">
        <div class="container">
          <div class="row gx-0">
            <div class="col-12">
              <h3 class="title text-center mb-4">Thank you for your interest in mentoring!</h3>
            </div>
            <div class="col-12 col-lg-6 offset-lg-3">
              <p class="text-center text-white">
                Please read the following information and click the button at the bottom of the page to begin your mentor application.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="page-summary means-to-mentor">
        <div class="container">
          <div class="row gx-0">
            <div class="col-12 col-lg-5">
              <h3 class="title">What Does it Mean to Mentor?</h3>
              <p>
                Mentors make an immensely positive impact on MnTC clients. The relationships they develop with clients are instrumental in building upon the work God has begun in their lives. Mentors encourage clients to live out their Christian faith in everyday situations while maintaining their sobriety, and the results can be life-changing!
              </p>
            </div>
            <div class="col-12 col-lg-5 offset-lg-2">
              <iframe title="vimeo-player" src="https://player.vimeo.com/video/641311560?h=4af433b51f" style="width: 100%; max-width: 100%; aspect-ratio: 16/9;" frameborder="0" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>

      <div class="mentor-roles">
        <div class="container">

          <div class="row gx-0 mb-4">
            <div class="col-12 col-lg-5">
              <img class="mb-5" src="@/assets/images/Picture1opt.jpg" alt="How are mentors and clients paired?">
            </div>
            <div class="col-12 col-lg-5 offset-lg-2">
              <h3 class="title mb-3">Who is eligible to mentor?</h3>
              <p class="mb-5">Mentors have a mature Christian faith, are at least 25 years of age, and have a valid driver's license. Mentors have two (2) years of freedom from any substance use dependence, treatment, or significant law violations.</p>
            </div>
          </div>

          <div class="row gx-0 mb-4">
            <div class="col-12 col-lg-5">
              <h3 class="title mb-3">How are mentors and clients paired?</h3>
              <p class="mb-5">All adult clients in MnTC's 13-month long-term program are eligible to be paired with a mentor, but client participation is voluntary. (Please note that clients in our teen boys program are not eligible for a mentor.) Male mentors are paired with male clients, and female mentors with female clients. Our Client Care Team works to determine a strong client-mentor pairing based on a number of factors. Individual requests to mentor a specific client cannot be honored. In order to be most effective, mentors may only mentor one client at a time.</p>
            </div>
            <div class="col-12 col-lg-5 offset-lg-2">
              <h3 class="title mb-3">What is the time commitment to mentor?</h3>
              <p class="mb-5">Mentors meet one-on-one with a client twice a month, in person, over the course of a year. These meetings typically take place on weekday afternoons and evenings, and over the weekend (except Sunday mornings). Mentors come to the MnTC location where their client lives, and they spend time together on-site or off-site. Most mentor meetings are around 2-4 hours in length. The total time commitment for mentor relationships is 12 months, but some mentor pairs choose to stay in touch beyond that timeframe!</p>
            </div>
          </div>
          
          <div class="row gx-0">
            <div class="col-12 col-lg-5">
              <h3 class="title mb-3">What is the process to become a mentor?</h3>
              <p class="mb-5">The first step is to create an account and fill out the mentor application. Once your application is reviewed and your background check is cleared, we will invite you to attend an in-person mentor orientation. Then you will meet with a member of the Client Care Team and be paired with a client!</p>
              <h3 class="title mb-3">WANT TO LEARN MORE?</h3>
              <p class="mb-5">Visit our <u><a class="text-dark" href="https://www.mntc.org/mentor/" target="_blank">FAQ page here</a></u>, or watch this video where you'll hear from a few MnTC mentors and clients!</p>
            </div>
            <div class="col-12 col-lg-5 offset-lg-2">
              <img class="mb-5" src="@/assets/images/Picture2opt.jpg" alt="What is the process to become a mentor?">
            </div>
          </div>

        </div>
      </div>

      <div class="our-process" id = "mentor_our_process">
        <div class="container">
          <div class="row gx-0 justify-content-center">
            <div class="col-9 col-md-12 text-center">
              <h3 class="sub-title"><span class="ribbon">Steps to become a mentor</span></h3>
            </div>
          </div>
          <div class="row gx-0">
            <div class="steps-container col-12 col-md-12 align-self-center text-center">
              <div class="steps d-flex justify-content-center">
                <div class="step-box col-5 col-md-2 align-self-center text-center"><span><i class="fa fa-check"></i></span><h3 class="font-size-14">Application Completed</h3></div>
                <div class="step-box col-5 col-md-2 align-self-center text-center"><span><i class="fa fa-check"></i></span><h3 class="font-size-14">Reference Confirmed</h3></div>
                <div class="step-box col-5 col-md-2 align-self-center text-center"><span><i class="fa fa-check"></i></span><h3 class="font-size-14">Background Check Approved</h3></div>
                <div class="step-box col-5 col-md-2 align-self-center text-center"><span><i class="fa fa-check"></i></span><h3 class="font-size-14">Orientation Completed</h3></div>
                <div class="step-box col-5 col-md-2 align-self-center text-center"><span><i class="fa fa-check"></i></span><h3 class="font-size-14">Meeting with MnTC Manager</h3></div>
                <div class="step-box col-5 col-md-2 align-self-center text-center"><span><i class="fa fa-check"></i></span><h3 class="font-size-14">Introduction to Mentee</h3></div>
              </div>
            </div>
            <div class="col-12 col-md-12 align-self-center text-center">
              <b-button @click="createAccount" variant="custom">Create Account to Begin Application</b-button>
            </div>
          </div>
        </div>
      </div>

      <div class="questions">
        <div class="container">
          <div class="row gx-0">
            <div class="col-12 col-md-12 col-lg-12 col-xl-7 align-self-center text-left">
              <h3 class="title text-center text-md-start">Questions ?</h3>
              <p class="text-center text-md-start">
                For more information on becoming a mentor at MnTC, please contact our Mentor
                Program Manager, Kristi Hedstrom
              </p>
            </div>
            <div class="col-12 col-md-12 col-lg-12 col-xl-5 align-self-center text-right pt-4 p-md-0 d-flex justify-content-center d-md-block">
              <!-- <a class="btn btn-custom" href="tel:6122386410">CALL NOW</a><strong class="center-or">OR</strong> -->
              <a class="btn btn-custom" href="mailto:kristi.hedstrom@mntc.org">EMAIL NOW</a>
            </div>
          </div>
        </div>
      </div>

    </section>
    <Footer></Footer>
  </div>
</template>